<div class="backIcon">
  <mat-icon
    class="close-icon"
    [routerLink]="['/private-space/view-valuation-requests']"
    >close</mat-icon
  >
</div>
<div class="text-center mat-header">Request a valuation</div>
<mat-card-content>
  <form
    [formGroup]="addValuationRequestsForm"
    (ngSubmit)="onSubmitAddForm()"
    class="row g-3 needs-validation"
  >
    <div class="form-group col-sm-12">
      <label for="searchProperty">Property</label>
      <input
        class="form-control"
        (keyup)="onSearchProperties($event)"
        id="searchProperty"
        placeholder="Search Property"
        formControlName="propertyName"
        type="text"
        value=""
      />
      <span
        class="validation-error"
        *ngIf="
          (customStylesValidated ||
            addValuationRequestsForm.controls.propertyName.touched) &&
          addValuationRequestsForm.controls.propertyName.errors?.required
        "
        >Please fill</span
      >
      <div *ngIf="propertiesResults" class="search-results">
        <div
          *ngIf="
            propertiesSearchResults.length == 0 && !displaySelectedProperty
          "
        >
          <!-- TODO -->
          <!-- <c-alert class="noMargins" color="warning">No results found for your property search!</c-alert> -->
        </div>

        <table *ngIf="propertiesSearchResults.length" class="table table-striped table-hover table-bordered" small>
          <thead>
            <tr>
              <th><small><b>Name</b></small></th>
              <th><small><b>Category</b></small></th>
              <th><small><b>Status</b></small></th>
              <th><small><b>No. of days</b></small></th>
              <th><small><b>Industry</b></small></th>
            </tr>
          </thead>
          <tbody>
            <tr
              (click)="onSelectProperty(property._source, property._id)"
              class="results-list"
              *ngFor="let property of propertiesSearchResults"
            >
              <td>{{ property._source.name }}</td>
              <td>{{ property._source.category }}</td>
              <td>{{ property._source.status }}</td>
              <td>{{ property._source.noOfDays }}</td>
              <td>{{ property._source.industry }}</td>
            </tr>
          </tbody>
        </table>

        <div class="card" *ngIf="displaySelectedProperty">
          <div class="card-body" class="noPadding">
            <table class="table table-striped table-hover table-bordered">
              <thead>
                <tr>
                  
                  <th><small><b>Name</b></small></th>
                  <th><small><b>Category</b></small></th>
                  <th><small><b>Industry</b></small></th>
                  <th><small><b>Status</b></small></th>
                  <th><small><b></b></small></th>
                </tr>
              </thead>
              <tbody>
                <tr>

                  <th>{{ selectedProperty.name }}</th>
                  <td>{{ selectedProperty.category }}</td>
                  <td>{{ selectedProperty.industry }}</td>
                  <td>{{ selectedProperty.status }}</td>
                  <td style="width: 10px;">
                    <mat-icon style="font-size: 17px;" (click)="removeProperty()"
                    type="button"
                    class="icon-button">delete</mat-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- <div class="text-center">
        <c-spinner *ngIf="isSearchingProperties" class="spinner" color="dark" variant="grow"></c-spinner>
      </div> -->
    </div>
    <div class="form-group col-sm-12">
      <label for="description">Description</label>
      <textarea
        class="form-control"
        id="description"
        formControlName="description"
        required
        type="text"
      ></textarea>
      <span
        class="validation-error"
        *ngIf="
          (customStylesValidated ||
            addValuationRequestsForm.controls.description.touched) &&
          addValuationRequestsForm.controls.description.errors?.required
        "
        >Please fill</span
      >
    </div>
    <div class="form-group col-sm-12">
      <label for="agencyName">Agency Name</label>
      <input
        class="form-control"
        id="agencyName"
        formControlName="agencyName"
        required
        type="text"
      />
      <span
        class="validation-error"
        *ngIf="
          (customStylesValidated ||
            addValuationRequestsForm.controls.agencyName.touched) &&
          addValuationRequestsForm.controls.agencyName.errors?.required
        "
        >Please fill</span
      >
    </div>
    <!-- <p-messages [value]="msgs"></p-messages> -->
    <div class="form-group col-sm-12 text-center" *ngIf="isLoading">
      <img
        class="loader"
        src="../../assets/images/loader.gif"
        width="60px"
        alt=""
      />
    </div>
    <div class="form-group col-sm-12">
      <button
        style="background-color: rgba(74, 116, 54, 255); color: #fff"
        class="btn btn-success"
        type="submit"
      >
        Submit form
      </button>
      <button
        style="background-color: black; color: #fff"
        class="btn"
        type="reset"
      >
        Reset
      </button>
      <div class="text-center">
        <!-- <c-spinner *ngIf="isLoading" class="spinner" color="dark" variant="grow"></c-spinner> -->
      </div>
    </div>
  </form>
</mat-card-content>
